module.exports = __webpack_public_path__ + "img/DE01454.c263bc47.png";